

    /**
     * Returns a function that call a method on the passed object
     */
    function func(name){
        return function(obj){
            return obj[name]();
        };
    }

    module.exports = func;





//////////////////
// WEBPACK FOOTER
// ./~/mout/function/func.js
// module id = 1593
// module chunks = 0 1 2